import { ArrowRightOutlined, CloseOutlined, EditOutlined, FileDoneOutlined, SearchOutlined, PlusOutlined, PrinterOutlined, DownloadOutlined, UploadOutlined } from "@ant-design/icons";

import { Button, Card, Col, Modal, Row, Space, Tooltip, Checkbox, Select, Form, Input, Tabs, Table, DatePicker, Upload } from "antd";
import React, { useState, useRef, useEffect, useMemo } from "react";
import Swal from "sweetalert2";
import * as yup from "yup";
import * as XLSX from 'xlsx';
import PageHeader from "../../view/pageheader";
import SelectInput from "../CustomComponents/SelectInput";
import TableComponent from "../CustomComponents/TableComponent";
import TextInput from "../CustomComponents/TextInput";
import { useDispatch, useSelector } from "react-redux";
import { getJobsList } from "../../store/reducer/jobSlice";
import { useNavigate } from "react-router-dom";
import { completeDisposition, getDispositionList } from "../../store/reducer/wearehouseSlice";
import Loader from "../../fields/Loader/Loader";
import dayjs from "dayjs";
import moment from "moment-timezone";
import { ImCheckboxChecked } from "react-icons/im";
import { toast } from "react-toastify";
const { TabPane } = Tabs;
const Disposition = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userId = localStorage.getItem('user_id');
    const role_id = localStorage.getItem("role_id");
    const [searchModal, setSearchModal] = useState(false)
    const [searchText, setSearchText] = useState('');
    const [searchDate, setSearchDate] = useState(null);
    const [activetab, setActiveTab] = useState('1');
    const [tab1SelectedKeys, setTab1SelectedKeys] = useState([]);
    const [tab1SelectedRows, setTab1SelectedRows] = useState([]);
    const [tab2SelectedKeys, setTab2SelectedKeys] = useState([]);
    const [tab2SelectedRows, setTab2SelectedRows] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [uploadModalVisible, setUploadModalVisible] = useState(false);
    const { completeDispositionSuccess, weareHouseLoading, getDispositionListData, } = useSelector((state) => state.wearehouse);
    const { data: tableData, count: totalCount, excelDatacount, excelData } = getDispositionListData
    function getData(payload = {}) {
        dispatch(getDispositionList({ ...payload, activetab })); // directly use variable
    }
    useEffect(() => {
        getData();
    }, [activetab]);
    useEffect(() => {
        if (completeDispositionSuccess) {
            toast.success("Disposition Boxes has been updated.");
            getData();
        }
    }, [completeDispositionSuccess]);

    const handleHardDiskUpdate = (record) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to mark this boxes as Disposition Completed?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Complete it!"
        }).then((result) => {
            if (result.isConfirmed) {
                const payload = [{
                    // completed_date: record.completed_date,
                    pickup_date: record.pickup_date,
                    job_spec_id: record.job_spec_id,
                    spec_id: record.spec_id,
                    // completed_date: moment().format("MM/DD/YYYY"),
                    // id: activetab == '1' ? record.id : record.disposition_table_id,
                    ...(activetab == '2' && { barcode: record.barcode })

                }]
                dispatch(completeDisposition({ postData: { datas: payload, activetab, type: 'entry' } }))

            }
        });
    };
    const pickupdateColumn = [
        {
            title: "Pickup Date",
            dataIndex: "pickup_date",
            key: "pickup_date",
            align: "center",
            render: (_, record) => (
                record.pickup_date == null ? 'N/A' : record.pickup_date
            )
            // render: (created_at) =>
            //     moment(created_at).tz("America/New_York").format("MM-DD-YYYY hh:mm A"),
            // align: "center",
        },
        {
            title: "Customer",
            dataIndex: "customername", // Ensure the correct key
            key: "customername",
            align: "center",
            // render: (_, record) => (
            //     record?.box_customer.customername
            // )
        },
        {
            title: "Spec",
            dataIndex: "spec_id",
            key: "spec_id",
            align: "center",
            // render: (_, record) => `${record.is_completed || 0} / ${record.input_number || 0}`,
        },
        {
            title: "No of Boxes",
            dataIndex: "no_of_boxes",
            key: "no_of_boxes",
            align: "center",
            // render: (_, record) => `${record.is_completed || 0} / ${record.input_number || 0}`,
        },

        // {
        //     title: "Hard Disk Delivered",
        //     dataIndex: "hard_disk_delivered",
        //     key: "hard_disk_delivered",
        //     align: "center",
        //     render: (_, record) => (
        //         <span>
        //             {record?.is_hard_disk == 0
        //                 ? "NA"
        //                 : record?.is_hard_disk_delivered == 1
        //                     ? "Yes"
        //                     : "No"} 
        //         </span>
        //     )

        // },
        {
            title: 'View Boxes',
            // dataIndex: "view_boxes",
            // key: "view_boxes",
            align: 'center',
            render: data => (
                <Space>
                    <Tooltip title="View Boxes">
                        <Button
                            shape="circle"
                            className="border-20"
                            icon={<ArrowRightOutlined style={{ color: "blue" }} />}
                            onClick={() =>
                                navigate("/view-boxes", {
                                    state: {
                                        spec_id: data.spec_id,
                                        job_spec_id: data.job_spec_id,
                                        pickup_date: data.pickup_date,
                                        type: 'disposition'
                                    },
                                })
                            }
                        />
                    </Tooltip>
                </Space>
            ),
        },
    ];



    const boxviewColumn = [
        {
            title: "Box Number",
            dataIndex: "barcode",
            key: "barcode",
            align: "center",
        },
        {
            title: "Customer",
            dataIndex: "customername", // fallback if box_customer is not loaded
            key: "customername",
            render: (_, record) => record.box_customer?.customername || "",
            align: "center",
        },
        {
            title: "Pickup Date",
            dataIndex: "pickup_date",
            key: "pickup_date",
            render: (_, record) => (
                record.pickup_date == null ? 'N/A' : record.pickup_date
            ),

            // render: (created_at) =>
            //     moment(created_at).tz("America/New_York").format("MM-DD-YYYY hh:mm A"),
            align: "center",
        },
        {
            title: "Spec",
            dataIndex: "spec_id",
            key: "spec_id",
            align: "center",
            // render: (_, record) => `${record.is_completed || 0} / ${record.input_number || 0}`,
        },
        {
            title: "Completed Date",
            dataIndex: "completed_date",
            key: "completed_date",
            align: "center",
            // render: (_, record) => `${record.is_completed || 0} / ${record.input_number || 0}`,
        },
        {
            title: "Hard Drive Delivered",
            dataIndex: "hard_disk_delivered",
            key: "hard_disk_delivered",
            align: "center",
            render: (_, record) => (
                <span>
                    {record?.is_hard_disk == 0
                        ? "N/A"
                        : record?.is_hard_disk_delivered == 1
                            ? "Yes"
                            : "No"}
                </span>
            )

        },
        {
            title: "Disposition Completed",
            key: "action",
            align: "center",
            render: (record) => (
                <Space>
                    <Tooltip title="Update Status">
                        <Checkbox
                            // checked={record?.is_last_stage === 1}
                            onChange={() => handleHardDiskUpdate(record)}
                        />
                    </Tooltip>
                </Space>
            ),
        }

    ];

    const handleSearchFilter = () => {
        const payloadData = {
            query: searchText,
        };


        // Add pickup_date only if selected
        if (searchDate) {
            payloadData.pickup_date = dayjs(searchDate).format('MM/DD/YYYY'); // send in MM/DD/YYYY format
        }
        getData(payloadData);
        setSearchModal(false)
        setSearchDate(null)
        setSearchText('');

    };
    const handleCancel = () => {
        setIsModalOpen(false);
        setFileList([]);
    };
    // Bulk update confirmation
    const handleBulkUpdate = () => {
        if (activetab == 1 ? tab1SelectedRows.length == 0 : tab2SelectedRows.length == 0) {
            return toast.error("Please select at least one box to update.");
        }
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to update these boxes?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Update it!"
        }).then((result) => {

            if (result.isConfirmed) {
                const payload = activetab == 1 ? tab1SelectedRows.map((data) => ({
                    // completed_date: data.completed_date,
                    // id: activetab == 1 ? data.id : data.disposition_table_id,
                    spec_id: data.spec_id,
                    job_spec_id: data.job_spec_id,
                    pickup_date: data.pickup_date,
                    ...(activetab == '2' && { barcode: data.barcode })

                })) : tab2SelectedRows.map((data) => ({
                    completed_date: data.completed_date,
                    id: activetab == 1 ? data.id : data.disposition_table_id,
                    ...(activetab == '2' && { barcode: data.barcode })
                }))

                // Dispatch your bulk update Redux action here
                dispatch(completeDisposition({ postData: { datas: payload, activetab } }))

            }
        });
    };


    // Download Excel Template
    const handleDownloadExcel = () => {
        if (!excelData || excelData.length === 0) {
            toast.error("No data available to download!");
            return;
        }
        // Define headers
        const headers = [
            "Box Number",
            "Pickup Date",
            "Customer",
            "Spec",
            "Completed Date",
            "Hard Drive Delivered",
            "Disposition Completed"
        ];

        // Map excelData into rows
        const dataRows = excelData.map((row) => [
            row.barcode || row.barcode || "",  // adapt field depending on tab
            row.pickup_date || "",
            row.customer_name || row.box_customer?.customername || "",
            row.spec_id || row.spec || "",
            row.completed_date || "",
            row.is_hard_disk_delivered == 1 ? "Yes" : "No", // export as 1/0
            row.is_disposition_completed == 1 ? "Yes" : "",
        ])

        // Combine headers + data
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...dataRows]);

        // Create workbook
        const workbook = XLSX.utils.book_new();

        // Append main sheet with actual data
        XLSX.utils.book_append_sheet(workbook, worksheet, "HardDiskStatus");

        // Create Reference sheet
        const referenceSheet = XLSX.utils.aoa_to_sheet([
            ["Value", "Meaning"],
            [Number(1), "Yes"],
            [Number(0), "No"],
        ]);

        XLSX.utils.book_append_sheet(workbook, referenceSheet, "Reference");

        // Export workbook
        XLSX.writeFile(workbook, "HardDisk_Update.xlsx");
    };
    const excelDateToJSDate = (serial) => {
        const utc_days = Math.floor(serial - 25569);
        const utc_value = utc_days * 86400; // seconds in a day
        const date_info = new Date(utc_value * 1000); // convert to ms
        return moment(date_info).format("MM/DD/YYYY");
    };

    const handleUpload = async () => {
        const allowedExtensions = ["xlsx", "xls", "xlsm", "xltx", "ods", "xlsb"];
        if (!fileList.length) {
            toast.error("Please select an Excel file to upload!");
            return;
        }

        const file = fileList[0];
        const fileExtension = file.name.split(".").pop().toLowerCase();

        if (!allowedExtensions.includes(fileExtension)) {
            toast.error("Invalid file type! Please upload a valid Excel file.");
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(sheet);

            let hasErrors = false;

            // if (jsonData.length > tableData.length) {
            //     toast.error("You have uploaded more records than allowed!");
            //     hasErrors = true;
            // }

            jsonData.forEach((row, index) => {
                if (!row["Box Number"]) {
                    toast.error(`Row ${index + 1}: Missing required Box Number.`);
                    hasErrors = true;
                }
                if (row["Completed Date"] && typeof row["Completed Date"] == "number") {
                    row["Completed Date"] = excelDateToJSDate(row["Completed Date"]);
                }
            });

            if (!hasErrors) {
                // Filter only rows with Hard Disk Delivered == 1
                const filteredRows = jsonData.filter(
                    (row) => row["Disposition Completed"] == 1
                );

                const payload = filteredRows.map((row) => ({
                    completed_date: row["Completed Date"] || null,
                    id: row["ID"] || null, // should come from Excel export
                    barcode: row["Box Number"]
                }));

                const postData = {
                    datas: payload,
                    activetab: "2",
                    type: 'excel'
                };
                dispatch(completeDisposition({ postData }));
                setFileList([]);
                setIsModalOpen(false);
                setUploadModalVisible(true)
            }


        };

        reader.readAsArrayBuffer(file);
    };
    const rowSelectionTab1 = {
        selectedRowKeys: tab1SelectedKeys,
        onChange: (newSelectedRowKeys, newSelectedRows) => {
            setTab1SelectedKeys(newSelectedRowKeys);
            setTab1SelectedRows(newSelectedRows);
        },
    };

    // Row selection for Tab 2
    const rowSelectionTab2 = {
        selectedRowKeys: tab2SelectedKeys,
        onChange: (newSelectedRowKeys, newSelectedRows) => {
            setTab2SelectedKeys(newSelectedRowKeys);
            setTab2SelectedRows(newSelectedRows);
        },
    };
    const showModal = () => {
        setIsModalOpen(true);
    };
    return (
        <div>
            {/* <Loader loading={prepTeamQueueLoading} /> */}
            <PageHeader HeaderText="Disposition Delivery" Breadcrumb={[{ name: "Update Delivery" }]} backButtonUrl="" />
           <Card style={{ marginTop: "-28px", }}>
                <Tabs
                    activeKey={activetab}
                    defaultActiveKey="1"
                    onChange={(key) => setActiveTab(key)}
                    type="card"
                    tabBarExtraContent={
                        <div style={{ display: "flex", gap: "10px" }}>
                            {/* <SearchComponent style={{ width: '250px' }}
                                placeholder="Search by Customer"
                            />
                            <DatePicker
                                style={{ width: '200px' }}
                                placeholder="Select Pickup Date"
                                value={searchDate}
                                onChange={(date) => setSearchDate(date)}
                                format="MM/DD/YYYY"
                            /> */}
                            <Button
                                style={{ gap: '10px' }}
                                className="btn btn-success"
                                icon={<ImCheckboxChecked style={{ marginRight: "8px" }} />}
                                shape="round"
                                // type="primary"
                                onClick={handleBulkUpdate}
                            >
                                Bulk Update Status
                            </Button>
                            <Button
                                style={{ backgroundColor: '#da7e22ff' }}
                                shape="round"
                                type="primary"
                                icon={<DownloadOutlined />}
                                onClick={handleDownloadExcel}
                            >
                                Download Template
                            </Button>
                            <Button
                                style={{ backgroundColor: '#7e0e0eff' }}
                                shape="round"
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={showModal}
                            >
                                Upload Excel
                            </Button>
                            {/* <Button
                                className="primary-btn"
                                icon={<SearchOutlined />}
                                shape="round"
                                type="primary"
                                onClick={() => setSearchModal(true)}
                            >
                                Search Filter By Date
                            </Button> */}
                        </div>
                    }
                >
                    <TabPane tab="Pickup Date View" key="1">
                        <TableComponent
                            rowSelection={rowSelectionTab1}
                            columns={pickupdateColumn}
                            dataSource={tableData}
                            rowKey="key"
                            // TotalDataCount={totalCount}
                            size="small"
                            onChangeDispatch={getData}
                        />
                    </TabPane>

                    <TabPane tab="Box View" key="2">
                        <TableComponent
                            rowSelection={rowSelectionTab2}
                            columns={boxviewColumn}
                            dataSource={tableData}
                            // TotalDataCount={totalCount}
                            size="small"
                            onChangeDispatch={getData}
                        />
                    </TabPane>
                </Tabs>

                <Modal
                    open={searchModal}
                    onCancel={() => setSearchModal(false)}
                    // footer={null}
                    onOk={handleSearchFilter}
                    okText="Search"
                    title={
                        <span>
                            Search Filter <SearchOutlined style={{ marginRight: 6 }} />
                            <hr />
                        </span>

                    }
                    width={600}
                >

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', }}>

                        {/* First Line: Spec or Customer Name */}
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <label style={{ marginBottom: '6px', fontWeight: 'bold' }}>Search by Spec or Customer</label>
                            <Input
                                placeholder="Enter Spec or Customer Name"
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                            />
                        </div>

                        {/* Second Line: Pickup Date */}
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <label style={{ marginBottom: '6px', fontWeight: 'bold' }}>Pickup Date</label>
                            <DatePicker
                                style={{ width: '100%' }}
                                placeholder="Filter By Pickup Date"
                                value={searchDate}
                                onChange={(date) => setSearchDate(date)}
                                format="MM/DD/YYYY"
                            />
                        </div>

                    </div>

                </Modal>
                <Modal title="Upload Excel File" open={isModalOpen} onOk={handleUpload} onCancel={handleCancel} okText="Upload">
                    <Upload
                        beforeUpload={(file) => {
                            setFileList([file]);
                            return false;
                        }}
                        fileList={fileList}
                        accept=".xlsx, .xls"
                    >
                        <Button icon={<UploadOutlined />}>Select Excel File</Button>
                    </Upload>
                </Modal>
            </Card>
            {weareHouseLoading ? <Loader /> : <>
                <Modal
                    title="Upload in Progress"
                    open={uploadModalVisible}
                    footer={[
                        <Button key="logs" type="primary" className='primary-btn' onClick={() => navigate("/upload-log", { state: { activeTab: "disposition" } })}>
                            Go to Upload Logs
                        </Button>,
                    ]}
                    onCancel={() => setUploadModalVisible(false)}
                >
                    <p>Data upload is in progress. Please check upload logs.</p>
                </Modal>
            </>}
        </div>
    );
};

export default Disposition;
